import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import Particle from "../Particle";
import Aboutcard from "./AboutCard";
import PageSeo from "../SEO/PageSeo";
import laptopImg from "../../Assets/about.png";
import { useLanguage } from "../../context/LanguageContext";

function About() {
  const { t } = useLanguage();
  return (
    <>
      <PageSeo
        title={t("seo.about.title")}
        description={t("seo.about.description")}
        breadcrumbItems={[
          { name: t("nav.home"), path: "/" },
          { name: t("nav.about"), path: "/about" },
        ]}
      />
      <Particle />
      <Container fluid className="about-section">
        <Container>
          <Row style={{ justifyContent: "center", padding: "10px" }}>
            <Col
              md={7}
              style={{
                justifyContent: "center",
                paddingTop: "30px",
                paddingBottom: "50px",
              }}
            >
              <h1 style={{ fontSize: "2.1em", paddingBottom: "20px" }}>
                {t("aboutPage.h1a")}
                <strong className="purple">{t("aboutPage.h1b")}</strong>
              </h1>
              <Aboutcard />
            </Col>
            <Col
              md={5}
              style={{ paddingTop: "120px", paddingBottom: "50px" }}
              className="about-img"
            >
              <img
                src={laptopImg}
                alt={t("aboutPage.imgAlt")}
                className="img-fluid"
              />
            </Col>
          </Row>
        </Container>
      </Container>
    </>
  );
}

export default About;
